import { render, staticRenderFns } from "./apiBody.vue?vue&type=template&id=0fa8fbae&scoped=true&"
import script from "./apiBody.vue?vue&type=script&lang=js&"
export * from "./apiBody.vue?vue&type=script&lang=js&"
import style0 from "./apiBody.vue?vue&type=style&index=0&id=0fa8fbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa8fbae",
  null
  
)

export default component.exports